import React from 'react';

/**
 * Fair Tracker mark (spec § 2): a gold hexagon with a navy inner hexagon and a
 * gold pin/compass diamond at the centre. 48×48 viewBox, as in the prototype.
 */
export default function FairLogo({ size = 28 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      aria-hidden="true"
      focusable="false"
      style={{ flex: 'none', display: 'block' }}
    >
      {/* Outer hexagon — gold */}
      <path d="M24 2 44 13v22L24 46 4 35V13z" fill="#E9B33C" />
      {/* Inner hexagon — navy */}
      <path d="M24 9.5 37.5 17v14L24 38.5 10.5 31V17z" fill="#0E1B33" />
      {/* Centre pin / compass diamond — gold */}
      <path d="M24 15.5 29.5 24 24 32.5 18.5 24z" fill="#E9B33C" />
    </svg>
  );
}
